import { ErrorHandler, Injectable } from '@angular/core';

const CHUNK_ERROR =
	/ChunkLoadError|Loading chunk .+ failed|Loading CSS chunk|(Failed to fetch|error loading) dynamically imported module|Importing a module script failed/i;
const RELOAD_KEY = 'app:chunk-reload-at';
const RELOAD_COOLDOWN_MS = 10_000;

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
	public handleError(error: unknown): void {
		const err = error as { message?: string; rejection?: { message?: string } };
		const message = err?.message ?? err?.rejection?.message ?? '';

		if (CHUNK_ERROR.test(message)) {
			this._reload();
			return;
		}
		console.error(error);
	}

	private _reload(): void {
		const now = Date.now();
		const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
		if (now - lastReload < RELOAD_COOLDOWN_MS) {
			return;
		}
		sessionStorage.setItem(RELOAD_KEY, String(now));
		window.location.reload();
	}
}
